import React from "react";
import { Result, Button, Collapse } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });

    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.logError(error, errorInfo);
  }

  logError = (error, errorInfo) => {
    try {
      const errorLog = {
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
      };

      const existingLogs = JSON.parse(
        localStorage.getItem("errorLogs") || "[]",
      );
      const updatedLogs = [errorLog, ...existingLogs].slice(0, 10);
      localStorage.setItem("errorLogs", JSON.stringify(updatedLogs));
    } catch (e) {
      console.error("Failed to log error:", e);
    }
  };

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  render() {
    if (this.state.hasError) {
      const isDevelopment = process.env.NODE_ENV === "development";

      return (
        <div style={{ padding: "50px", textAlign: "center" }}>
          <Result
            status="error"
            title="出错了"
            subTitle={this.state.error?.message || "页面遇到了一些问题"}
            extra={[
              <Button
                type="primary"
                key="reload"
                onClick={() => window.location.reload()}
              >
                刷新页面
              </Button>,
              <Button key="reset" onClick={this.handleReset}>
                返回
              </Button>,
            ]}
          />

          {isDevelopment && this.state.error && (
            <div
              style={{
                marginTop: "20px",
                textAlign: "left",
                maxWidth: "800px",
                margin: "20px auto",
              }}
            >
              <Collapse
                items={[
                  {
                    key: "1",
                    label: "查看详情",
                    children: (
                      <>
                        <div style={{ marginBottom: "10px" }}>
                          <strong>错误信息:</strong>
                          <pre
                            style={{
                              background: "#f5f5f5",
                              padding: "10px",
                              borderRadius: "4px",
                              overflow: "auto",
                            }}
                          >
                            {this.state.error.message}
                          </pre>
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                          <strong>错误堆栈:</strong>
                          <pre
                            style={{
                              background: "#f5f5f5",
                              padding: "10px",
                              borderRadius: "4px",
                              overflow: "auto",
                              fontSize: "12px",
                            }}
                          >
                            {this.state.error.stack}
                          </pre>
                        </div>
                        {this.state.errorInfo?.componentStack && (
                          <div>
                            <strong>组件堆栈:</strong>
                            <pre
                              style={{
                                background: "#f5f5f5",
                                padding: "10px",
                                borderRadius: "4px",
                                overflow: "auto",
                                fontSize: "12px",
                              }}
                            >
                              {this.state.errorInfo.componentStack}
                            </pre>
                          </div>
                        )}
                      </>
                    ),
                  },
                ]}
              />
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
